
      import API from "!../.yarn/__virtual__/style-loader-virtual-df9eec7ae0/0/cache/style-loader-npm-3.3.1-4bbb6ec77f-470feef680.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../.yarn/__virtual__/style-loader-virtual-df9eec7ae0/0/cache/style-loader-npm-3.3.1-4bbb6ec77f-470feef680.zip/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../.yarn/__virtual__/style-loader-virtual-df9eec7ae0/0/cache/style-loader-npm-3.3.1-4bbb6ec77f-470feef680.zip/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../.yarn/__virtual__/style-loader-virtual-df9eec7ae0/0/cache/style-loader-npm-3.3.1-4bbb6ec77f-470feef680.zip/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../.yarn/__virtual__/style-loader-virtual-df9eec7ae0/0/cache/style-loader-npm-3.3.1-4bbb6ec77f-470feef680.zip/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../.yarn/__virtual__/style-loader-virtual-df9eec7ae0/0/cache/style-loader-npm-3.3.1-4bbb6ec77f-470feef680.zip/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../.yarn/__virtual__/css-loader-virtual-56af4c3a41/0/cache/css-loader-npm-5.2.7-e1e8b8d16f-fb0742b30a.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./root-component.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../.yarn/__virtual__/css-loader-virtual-56af4c3a41/0/cache/css-loader-npm-5.2.7-e1e8b8d16f-fb0742b30a.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./root-component.css";
       export default content && content.locals ? content.locals : undefined;
